import { Component } from '@verndale/core';
import Swiper, { Navigation, Thumbs } from 'swiper';
import { debounce, matches } from 'lodash';
import { BREAKPOINTS, KEYS } from '../constants';

Swiper.use([Navigation, Thumbs]);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $thumbsGallery: this.el._$('.gallery-row__thumbs'),
      $thumbsContainer: this.el._$('.gallery-row__thumbs-container'),
      $thumbsWrapper: this.el._$('.gallery-row__thumbs-wrapper'),
      $thumbs: this.el._$$('.gallery-row__thumb'),
      $singlePicture: this.el._$('.gallery-row__preview picture'),
      $singleImg: this.el._$('.gallery-row__preview img'),
      $previewsContainer: this.el._$('.gallery-row__previews-container'),
      $previews: this.el._$$('.gallery-row__previews-slide'),
      $prev: this.el._$('.gallery-row__swiper-btn-prev'),
      $next: this.el._$('.gallery-row__swiper-btn-next'),
      $videoTriggers: this.el._$$('.gallery-row__preview__play-video-btn'),
      $videoIframes: this.el._$$('.gallery-row__preview__video__iframe')
    };
    this.activeThumbClass = 'swiper-slide-thumb-active';
    this.fullWidthImg = this.dom.$singlePicture.dataset.fullWidthImage;

    this.moveThumbsToContainer();

    if (!this.el.classList.contains('isExperienceEditor')){
      this.initSliders();
      this.initVideos();
    }
  }

  moveThumbsToContainer(){
    this.dom.$thumbs.forEach(el => {
      this.dom.$thumbsWrapper.appendChild(el);
    })
  }

  addListeners(){
    if (!this.el.classList.contains('isExperienceEditor')) this.dom.$videoTriggers.forEach(el => el._on('click', this.handlePlayClick.bind(this)));
    window.addEventListener('resize', debounce(this.handleResize.bind(this), 300));
  }

  initSliders() {
    if (this.dom.$previews.length === 1) {
      this.el.classList.add('gallery-row--single-slide')
      this.dom.$singleImg.src = this.fullWidthImg;
    }
    this.el.dataset.slideCount = this.dom.$previews.length
    if (this.dom.$previews.length > 1){
      this.dom.$thumbsGallery.style.display = 'block';
      this.thumbsSlider = new Swiper(this.dom.$thumbsContainer, {
        allowTouchMove:false,
        watchSlidesProgress: true,
        spaceBetween: 10,
        slidesPerView: this.dom.$thumbs.length >= 4 ? 4 : this.dom.$thumbs.length,
        breakpoints: {
          1024: {
            direction: 'vertical',
            spaceBetween: 25,
            slidesPerView: this.dom.$thumbs.length >= 3 ? 3 : this.dom.$thumbs.length
          }
        }
      });
    }

    this.previewsSlider = new Swiper(this.dom.$previewsContainer, {
      loop: this.dom.$previews.length > 1 ? true : false,
      thumbs: {
        swiper: this.thumbsSlider
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },
      navigation: {
        prevEl: this.dom.$prev,
        nextEl: this.dom.$next
      },
      breakpoints: {
        1024:{
          allowTouchMove: false
        }
      }
    });

    this.previewsSlider.on('slideChange', () => {
      this.resetSlides();
    });

    this.handleResize();
  }

  initVideos(){
    this.dom.$previews = this.el._$$('.gallery-row__previews-slide');
    this.dom.$videoTriggers = this.el._$$('.gallery-row__preview__play-video-btn');
    this.dom.$videoIframes = this.el._$$('.gallery-row__preview__video__iframe');

    this.dom.$previews.forEach(el => el._$('picture').style.display = null);
    this.dom.$videoIframes.forEach(el =>  {
      el.videoSrc = el.getAttribute('src').trim();
      el.style.transitionDuration = '0ms';
      el.style.transitionDelay = '0ms';
      el.style.opacity = '0';
      el.style.display = 'none';
    });
    this.dom.$videoTriggers.forEach(el => {
      el.hidden = false;
    });
    this.dom.$thumbs = this.el._$$('.gallery-row__thumb');
    this.dom.$thumbs.forEach((el, i) => {
      el._on('keydown', this.handleKeyDown.bind(this, i))
      if (i) el.setAttribute('tabindex', '0');
    });
  }

  resetSlides(){
    this.dom.$previews.forEach(el => el._$('picture').style.display = null);
    this.dom.$videoIframes.forEach(el => {
      el.setAttribute('src', el.videoSrc)
      el.style.transitionDuration = '0ms';
      el.style.transitionDelay = '0ms';
      el.style.opacity = '0';
    });
    this.dom.$videoTriggers.forEach(el => {
      el.hidden = false;
    });
  }

  async handlePlayClick(e){
    const activeSlide = this.el._$('.swiper-slide-active');
    const activeIframe = activeSlide._$('.gallery-row__preview__video__iframe');
    const activeButton = activeSlide._$('.gallery-row__preview__play-video-btn');
    if (!activeButton) return;
    activeButton.hidden = true;
    activeSlide._$('picture').style.display = 'none';
    activeIframe.style.transitionDuration = '500ms';
    activeIframe.style.transitionDelay = '300ms';
    activeIframe.style.display = 'block';
    // eslint-disable-next-line no-undef
    await new Promise(resolve => {
      requestAnimationFrame(() => resolve());
    });
    activeIframe.style.opacity = '1';

    const videoSrc = activeIframe.getAttribute('src').trim()
    const isWistia = videoSrc.includes('wistia')

    if (isWistia) activeIframe.setAttribute('src', `${videoSrc}?autoPlay=true&muted=true`)
    else activeIframe.setAttribute('src', `${videoSrc}?autoplay=1&mute=1`)
  }

  handleKeyDown(i, e) {
    let nextIdx = null;

    switch (e.which) {

    case KEYS.LEFT:
      nextIdx = i === 0 ? null : i - 1;
      break;
    case KEYS.RIGHT:
      nextIdx = i === this.dom.$thumbs.length - 1 ? null : i + 1;
      break;
    default:
      break;
    }

    if (nextIdx !== null) {
      this.dom.$thumbs.forEach(el => el.setAttribute('tabindex', '-1'));
      this.previewsSlider.slideTo(nextIdx + 1);
      this.dom.$thumbs[nextIdx].removeAttribute('tabindex');
      this.dom.$thumbs[nextIdx].focus();
    }
  }

  handleResize(){
  }
}

export default Module;
